import {API_STATUS} from '../utils/constants';
import {getImageUrl} from '../utils/images';

const getRecentActivityDetails = (state, linkId) => {
    const scratchpad = state.recentActivity && state.recentActivity.summaries && state.recentActivity.summaries.find((summary) => {
        return summary.linkId === linkId;
    });

    if (scratchpad) {
        scratchpad.isDated = !!(scratchpad.arrivalDate && scratchpad.departureDate);
    }

    return scratchpad || null;
};

const getSummaries = (state) => state.recentActivity && state.recentActivity.summaries || [];

const getFetchState = (state) => {
    const fetch = state.recentActivity && state.recentActivity.fetch;
    return {
        isFetched: fetch === API_STATUS.SUCCESS || fetch === API_STATUS.ERROR,
        fetch
    };
};

// RecentActivityCarousel
const getRecentActivityCarousel = (state) => {
    const summaries = getSummaries(state);
    return summaries.map((summary) => {

        const {arrivalDate, endDate, departureDate, lbsGroupName, lbsUuid, propertiesSummary = {}, scratchpadId, startDate, imageUrl} = summary;
        const {properties = []} = propertiesSummary;
        const firstImageUrl = properties[0] && properties[0].hit && properties[0].hit.thumbnailUrl1;
        const count = properties.length;
        const imageUri = imageUrl || firstImageUrl;
        return {
            startDate: arrivalDate,
            count,
            endDate: departureDate,
            searchEndDate: endDate,
            searchStartDate: startDate,
            title: lbsGroupName,
            lbsUuid,
            key: scratchpadId,
            id: scratchpadId,
            imageUri: getImageUrl(imageUri)
        };
    });
};

// RecentActivityCarousel
const getCardIndex = (state) => state.recentActivity && state.recentActivity.cardIndex;

export default {
    getFetchState,
    getRecentActivityDetails,
    getCardIndex,
    getRecentActivityCarousel,
    getSummaries
};



// WEBPACK FOOTER //
// ./src/universal/recent-activity/selectors.js